import angular from 'angular';

import ResetPasswordService from './reset-password.service';

export default angular
    .module('application.scene.identity.scene.forgot-password.service', [])
    .service('resetPasswordService', ResetPasswordService);



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/service/index.js